import Model from './BaseModel';
import ApiService from '@/Services/ApiService.js';

export default class TwoFactor extends Model {
	resourceName() {
		return 'two_factor';
	}

	enroll(data) {
		return ApiService.post(`${this.resourceUrl()}enroll`, data);
	}

	enable(data) {
		return ApiService.post(`${this.resourceUrl()}enable`, data);
	}

	qrCode() {
		return ApiService.get(`${this.resourceUrl()}qr_code`);
	}

	disable() {
		return ApiService.post(`${this.resourceUrl()}disable`);
	}

	regenerateRecoveryCodes() {
		return ApiService.post(`${this.resourceUrl()}recovery_codes`);
	}
}
